import { isTileOccupied, getIsoPosition } from '../index';
import {
  setActiveHeroTileColor,
  clearActiveHeroTileColor,
  setAvailableMoveTilesColor,
  clearAvailableMoveTilesColor,
  clearAllTilesColor,
} from '../Color';
import { spawnCommandButtons } from '../Spawn';
import AnimationKeys from '../../../constants/AnimationKeys';
import {
  HERO_INIT_ISO_POS,
  HERO_MOVING_SPEED,
  HERO_INIT_FRAME_LEFT,
  HERO_INIT_FRAME_RIGHT,
} from '../../../configs/Battle';

// Initialize available move tiles of the active hero
export function spawnAvailableMoveTiles() {
  if (!this.isMovable) {
    return;
  }

  const { posX, posY, movingRange } = this.activeHero;
  let tile;

  this.availableMoveTiles = [];

  for (let i = 1; i <= movingRange; i++) {
    tile = this.tiles?.[posX - i]?.[posY];
    if (tile) {
      this.availableMoveTiles.push({ posX: posX - i, posY });
    }
    tile = this.tiles?.[posX + i]?.[posY];
    if (tile) {
      this.availableMoveTiles.push({ posX: posX + i, posY });
    }

    for (let j = 1; j <= movingRange - i; j++) {
      tile = this.tiles?.[posX - i]?.[posY - j];
      if (tile) {
        this.availableMoveTiles.push({ posX: posX - i, posY: posY - j });
      }
      tile = this.tiles?.[posX - i]?.[posY + j];
      if (tile) {
        this.availableMoveTiles.push({ posX: posX - i, posY: posY + j });
      }
      tile = this.tiles?.[posX]?.[posY - j];
      if (tile) {
        this.availableMoveTiles.push({ posX, posY: posY - j });
      }
      tile = this.tiles?.[posX]?.[posY + j];
      if (tile) {
        this.availableMoveTiles.push({ posX, posY: posY + j });
      }
      tile = this.tiles?.[posX + i]?.[posY - j];
      if (tile) {
        this.availableMoveTiles.push({ posX: posX + i, posY: posY - j });
      }
      tile = this.tiles?.[posX + i]?.[posY + j];
      if (tile) {
        this.availableMoveTiles.push({ posX: posX + i, posY: posY + j });
      }
    }
  }

  tile = this.tiles?.[posX]?.[posY - movingRange];
  if (tile) {
    this.availableMoveTiles.push({ posX, posY: posY - movingRange });
  }
  tile = this.tiles?.[posX]?.[posY + movingRange];
  if (tile) {
    this.availableMoveTiles.push({ posX, posY: posY + movingRange });
  }

  clearAllTilesColor.call(this, false);
  setAvailableMoveTilesColor.call(this);
  this.availableAttackTiles = [];
}

// Clear available move tiles of the active hero
export function clearAvailableMoveTiles() {
  clearAllTilesColor.call(this, false);
  this.availableMoveTiles = [];
}

// Move a hero to a target position
export function moveHero(hero, posX, posY) {
  const { id, isoSprite: heroSprite, posX: heroPosX, posY: heroPosY } = hero;
  const { isoPosX, isoPosY } = getIsoPosition(this.tiles[posX][posY]);
  const { isoPosZ } = HERO_INIT_ISO_POS;
  const speed = HERO_MOVING_SPEED;

  this.movingHero = {
    id,
    isoSprite: heroSprite,
    isoPosX,
    isoPosY,
    isoPosZ,
    speed,
    moveLeft:
      (heroPosX > posX && heroPosY <= posY) ||
      (heroPosX === posX && heroPosY < posY),
  };

  hero.posX = posX;
  hero.posY = posY;

  heroSprite.body.moves = true;
  this.isoPhysics.moveToXYZ(heroSprite, isoPosX, isoPosY, isoPosZ, speed);
}

// Get ready to move a hero
export function preMoveHero(isoX, isoY) {
  for (let i = 0; i < this.availableMoveTiles.length; i++) {
    const { posX, posY } = this.availableMoveTiles[i];
    const tile = this.tiles[posX][posY];

    if (isoX === tile.isoX && isoY === tile.isoY) {
      if (isTileOccupied.call(this, posX, posY)) {
        return;
      }

      clearActiveHeroTileColor.call(this);
      clearAvailableMoveTilesColor.call(this);
      this.availableMoveTiles = [];
      moveHero.call(this, this.activeHero, posX, posY);
      break;
    }
  }
}

// Animate a hero to walk to the target position
export function postMoveHero() {
  const {
    id,
    isoSprite: heroSprite,
    isoPosX,
    isoPosY,
    isoPosZ,
    speed,
    moveLeft,
  } = this.movingHero;

  let heroWalkAnimationKey;
  if (moveLeft) {
    heroWalkAnimationKey = `${AnimationKeys.HeroWalkLeft}-${id}`;
  } else {
    heroWalkAnimationKey = `${AnimationKeys.HeroWalkRight}-${id}`;
  }
  heroSprite.anims.play(heroWalkAnimationKey, true);

  const distance = this.isoPhysics.distanceToXYZ(
    heroSprite.body,
    isoPosX,
    isoPosY,
    isoPosZ,
    speed,
  );

  if (distance < 4) {
    heroSprite.isoPosition.setTo(isoPosX, isoPosY, isoPosZ);
    heroSprite.body.moves = false;
    heroSprite.anims
      .stop(null, true)
      .setFrame(moveLeft ? HERO_INIT_FRAME_LEFT : HERO_INIT_FRAME_RIGHT);

    this.movingHero = null;
    this.isMovable = false;
    setActiveHeroTileColor.call(this);
    if (this.commandButtons) {
      spawnCommandButtons.call(this, true);
    }
  }
}
